import { SanityColor } from '@data/sanity/queries/types/modules'

export const backgroundColorClassMap: Record<SanityColor, string | string[]> = {
  [SanityColor.WHITE]: 'bg-white text-black',
  [SanityColor.GRAY]: 'bg-gray text-black',
  [SanityColor.GREEN_LIGHT]: 'bg-green-light text-black',
  [SanityColor.GREEN]: 'bg-green text-white',
  [SanityColor.GREEN_ELECTRIC]: 'bg-green-electric text-white',
  [SanityColor.GREEN_DARK]: 'bg-green-dark text-white',
  [SanityColor.PINK_FADED]: 'bg-pink-faded text-black',
  [SanityColor.PINK]: 'bg-pink text-white text-black',
  [SanityColor.PINK_HOT]: 'bg-pink-hot text-white',
  [SanityColor.BLUE]: 'bg-blue text-white',
  [SanityColor.RED]: 'bg-red text-white',
  [SanityColor.YELLOW]: 'bg-yellow text-black',
}
